import { useEffect, useState } from "react";
import { Smartphone, X } from "lucide-react";

// PWA install banner — appears once per session on mobile after login when app is installable.
export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const dismissed = (() => { try { return sessionStorage.getItem("pwa-dismissed") === "1"; } catch { return false; } })();
    if (dismissed) return;
    // iOS Safari doesn't fire beforeinstallprompt — detect and show hint
    const ua = navigator.userAgent;
    const isiOS = /iphone|ipad|ipod/i.test(ua) && !window.MSStream;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;
    if (isiOS) {
      setIsIOS(true);
      setTimeout(() => setVisible(true), 5000);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setTimeout(() => setVisible(true), 4000);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    setVisible(false);
    try { sessionStorage.setItem("pwa-dismissed", "1"); } catch { /* ignore */ }
  };

  if (!visible) return null;

  return (
    <div data-testid="pwa-banner" className="fixed inset-x-3 bottom-3 z-50 md:left-auto md:right-6 md:bottom-6 md:w-96 paper rounded-2xl p-4 shadow-2xl border border-[#E8E2D8]" style={{background:"linear-gradient(135deg, #FFFFFF, #FAF7F2)"}}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#EF3E36] text-white flex items-center justify-center shrink-0">
          <Smartphone className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-[#2B3A33] text-base">Installa Amunì sul telefono</div>
          {isIOS ? (
            <p className="text-xs text-[#6B6558] mt-1">Tocca <b>Condividi</b> sulla barra di Safari, poi <b>Aggiungi a Home</b>. Avrai Amunì come app!</p>
          ) : (
            <p className="text-xs text-[#6B6558] mt-1">Accedi più velocemente alle news, votazioni e tessera digitale.</p>
          )}
          <div className="mt-3 flex gap-2">
            {!isIOS && deferred && (
              <button data-testid="pwa-install-btn" onClick={install} className="terracotta-btn px-4 py-2 rounded-lg text-sm font-semibold">Installa</button>
            )}
            <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="px-4 py-2 rounded-lg text-sm border border-[#E8E2D8] text-[#6B6558] hover:bg-white">Più tardi</button>
          </div>
        </div>
        <button onClick={dismiss} className="text-[#8A8272] hover:text-[#2B3A33] p-1" aria-label="Chiudi">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
